import Card from 'app/frontend/base/components/Card'
import { Skeleton } from '@/components/ui/skeleton'

const GlobalNewsItemSkeleton = () => {
  return (
    <Card className='p-0'>
      <header className='p-4 border-b border-border'>
        <div className='flex items-center gap-3 min-w-0'>
          <Skeleton className='w-24 h-18 shrink-0 border-0' />
          <div className='flex flex-col gap-2 min-w-0 flex-1'>
            <Skeleton className='h-6 w-2/3 border-0 opacity-40' />
            <Skeleton className='h-4 w-1/3 border-0 opacity-40' />
          </div>
        </div>
      </header>

      <div className='p-4 flex flex-col gap-3'>
        <Skeleton className='h-4 w-full border-0 opacity-40' />
        <Skeleton className='h-4 w-11/12 border-0 opacity-40' />
        <Skeleton className='h-4 w-10/12 border-0 opacity-40' />
        <Skeleton className='h-4 w-5/6 border-0 opacity-40' />
        <Skeleton className='h-4 w-3/4 border-0 opacity-40' />
      </div>
    </Card>
  )
}

export default GlobalNewsItemSkeleton
